<template>
  <v-app-bar
    app
    dark
    :color="color"
    class="HeaderAppMobile hidden-md-and-up"
  >
    <v-toolbar-title>
      <v-img
        contain
        :src="logo"
        max-width="150px"
        class="mr-5"
      />
    </v-toolbar-title>

    <v-spacer />
    <v-app-bar-nav-icon @click.stop="dialog = !dialog" />

    <v-dialog
      v-model="dialog"
      fullscreen
      persistent
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          flat
          class="d-flex justify-center mt-16"
          :color="toolBarColor"
        >
          <div
            v-if="showValidateButton"
            class="d-flex align-center justify-center"
          >
            <HeaderCompletion
              v-if="customerFileCompletion.toFixed(0) < 100"
              class="my-6 mr-6"
              :completion="customerFileCompletion.toFixed(0)"
            />
            <v-btn
              :disabled="customerFileCompletion.toFixed(0) < 100"
              text
              class="theme-btn app-button-success nice-padding mr-6"
              @click="alertDialog = true"
            >
              {{ $t('subscription.validation.btn') }}
            </v-btn>
          </div>
        </v-toolbar>
        <v-list
          class="my-4"
          dense
          nav
        >
          <v-list-item-group v-model="selected">
            <div v-if="adminHeader">
              <v-list-item
                v-for="(item, i) in navMobile"
                :key="i"
                :to="item.to"
                @click.stop="goTo(item.to)"
              >
                <v-list-item-icon>
                  <v-avatar
                    size="25"
                    :color="avatarColor"
                  >
                    <v-icon
                      size="15"
                      :color="iconColor"
                      v-text="item.icon"
                    />
                  </v-avatar>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    :color="color"
                    v-text="item.label"
                  />
                </v-list-item-content>
              </v-list-item>
            </div>
            <v-list-item @click="onClickLogout">
              <v-list-item-icon>
                <v-avatar
                  size="25"
                  :color="avatarColor"
                >
                  <v-icon
                    size="15"
                    dark
                    :color="iconColor"
                  >
                    mdi-logout-variant
                  </v-icon>
                </v-avatar>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title :color="color">
                  {{ $t('common.logout') }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card>
    </v-dialog>
    <WeDialog
      :isDisplay.sync="alertDialog"
      imgUrl="add-doc.svg"
      title="subscription.validation.alert.title"
      description="subscription.validation.alert.description"
    >
      <v-btn
        text
        class="theme-btn app-button-primary color nice-padding"
        @click="redirectToValidation"
      >
        {{ $t('subscription.validation.btn') }}
      </v-btn>

      <v-btn
        text
        class="theme-btn app-button-secondary color-white nice-padding mt-2"
        @click="alertDialog = false"
      >{{ $t('common.action.later') }}</v-btn>
    </WeDialog>
  </v-app-bar>
</template>

<script>
  import CommonMixin from '@/mixins/store/CommonMixin'
  import getColor from '@/utils/getColor'
  import WeDialog from '@/components/ui/common/Dialog/Dialog'

  import ApiService from '@/services/ApiService'
  import HeaderCompletion from '@/components/ui/partials/HeaderApp/HeaderCompletion/HeaderCompletion'
  import { PERSON_STATUS } from '@/services/models.const'

  export default {
    components: {
      HeaderCompletion,
      WeDialog,
    },
    mixins: [CommonMixin,],
    props: {
      logo: {
        type: String,
        required: true,
      },
      color: {
        type: String,
        default: getColor('_1f368b'),
      },
      adminHeader: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        alertDialog: false,
        dialog: false,
        selected: 0,
        avatarColor: getColor('_009ee0'),
        iconColor: getColor('_ffffff'),
        toolBarColor: getColor('transparent'),
        navMobile: [],
      }
    },
    computed: {
      showValidateButton() {
        if (this.$route.name === 'Validation') {
          return false
        }

        return (
          !this.adminHeader &&
          [PERSON_STATUS.created, PERSON_STATUS.pending,].includes(this.currentUser.meta.customer_file_status)
        )
      },
    },
    methods: {
      goTo(to) {
        this.dialog = false

        setTimeout(() => {
          this.$router.push({ name: to, })
        })
      },
      async onClickLogout() {
        if (localStorage.getItem('access_token')) {
          const result = await ApiService.logout(localStorage.getItem('access_token'))
          if (result.errors) {
            this.$message({
              type: 'error',
              text: 'logout_error',
            })
          } else {
            localStorage.clear()
            const path = this.$route.path
            const name = path.match(/crm/) ? 'LoginCRM' : 'Login'
            const loginRoute = { name, }
            this.$router.push(loginRoute)
          }
        } else {
          this.$message({
            type: 'error',
            text: 'logout_error',
          })
        }
      },
      redirectToValidation() {
        this.$router.push({ name: 'Validation', })
        this.alertDialog = false
      },
    },
  }
</script>

<style scoped lang="scss">
.HeaderAppMobile {
  background-color: $color-102d69 !important;
  .picto {
    width: 35px;
    height: 35px;
  }
  .header-divider {
    background-color: $color-020d24;
    height: 28px;
    opacity: 80%;
    width: 2px;
    margin-top: 10px;
  }
}
</style>
